import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-line-data"},"children":[{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 7.5C21 8.32843 20.3284 9 19.5 9C18.6716 9 18 8.32843 18 7.5C18 6.67157 18.6716 6 19.5 6C20.3284 6 21 6.67157 21 7.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M8.25025 15.7983C7.53281 16.2125 6.61543 15.9667 6.20121 15.2493C5.787 14.5318 6.03281 13.6144 6.75025 13.2002C7.46769 12.786 8.38508 13.0318 8.79929 13.7493C9.2135 14.4667 8.96769 15.3841 8.25025 15.7983Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.79932 13.7499L18.1999 8.26074M21 7.5C21 8.32843 20.3284 9 19.5 9C18.6716 9 18 8.32843 18 7.5C18 6.67157 18.6716 6 19.5 6C20.3284 6 21 6.67157 21 7.5ZM8.25025 15.7983C7.53281 16.2125 6.61543 15.9667 6.20121 15.2493C5.787 14.5318 6.03281 13.6144 6.75025 13.2002C7.46769 12.786 8.38508 13.0318 8.79929 13.7493C9.2135 14.4667 8.96769 15.3841 8.25025 15.7983Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartLineData = Vue.extend<IconProps>({
  name: 'ChartLineDataIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-line-data',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartLineData;
